




























































































































































































import HomeAgendamentoStore from '@/components/Home/Store/HomeAgendamentoStore'
import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { contains } from '@/utils/common'
import moment from 'moment'

@Component
export default class ComponentCardAgendamento extends Vue {
  agendamentoEnabled: boolean = false
  dataReady: boolean = false

  get getHomeAgendamentoStore() {
    return getModule(HomeAgendamentoStore, this.$store)
  }

  get agendamentosMesAtualTotal() {
    return this.getHomeAgendamentoStore.agendamentosMesAtualTotal || 0
  }

  get agendamentosMesAnteriorTotal() {
    return this.getHomeAgendamentoStore.agendamentosMesAnteriorTotal || 0
  }

  get agendamentosAnoAtualTotal() {
    return this.getHomeAgendamentoStore.agendamentosAnoAtualTotal || 0
  }

  get agendamentosTotal() {
    return this.getHomeAgendamentoStore.agendamentosTotal || 0
  }

  get trendingPercentage() {
    if (this.agendamentosMesAnteriorTotal === 0) return '0%'
    return `${Math.round((this.agendamentosMesAtualTotal / this.agendamentosMesAnteriorTotal - 1) * 100)}%`
  }

  get trendingData() {
    if (this.agendamentosMesAnteriorTotal === 0) return { color: 'blue darken-2', icon: 'mdi-trending-neutral', class: 'neutral' }
    if (this.agendamentosMesAtualTotal > this.agendamentosMesAnteriorTotal) return { color: 'green darken-2', icon: 'mdi-trending-up', class: 'positive' }
    if (this.agendamentosMesAtualTotal < this.agendamentosMesAnteriorTotal) return { color: 'red darken-2', icon: 'mdi-trending-down', class: 'negative' }
    return { color: 'blue darken-2', icon: 'mdi-trending-neutral', class: 'neutral' }
  }

  get proximasCirurgias() {
    return this.getHomeAgendamentoStore.proximasCirurgias || []
  }

  formatDateAndTime(date: string) {
    if (['', null, undefined].includes(date)) return 'Não informado'
    return `${moment(date).format('DD/MM/YYYY')} às ${moment(date).format('HH:mm')}`
  }

  formatStatusColor(value: string) {
    switch (value) {
      case 'Autorizada':
        return '#00FF66'
      case 'AnalisePreAutorizacao':
        return '#FFA800'
      default:
        return '#333333'
    }
  }

  async init() {
    const request = await this.getHomeAgendamentoStore.getAgendamentoSummaryData()
    if (request.success) {
      this.dataReady = true
    }
  }

  async created() {
    if (contains(this.$user.profile.pageAuthorized, ['agendamento-medico'])) {
      this.agendamentoEnabled = true
      await this.init()
    }
  }

  windowWidth: number = 0

  get mobileBreakpoint() {
    return this.windowWidth < 768
  }

  get tabletBreakpoint() {
    return this.windowWidth < 960
  }

  getWindowWidth() {
    this.windowWidth = document.documentElement.clientWidth
  }

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }

  updated() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }
}
